'use client'

import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useRouter } from '@/lib/next-shim'
import { useSession } from '@/shared/ui/providers/AuthSessionProvider'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { status } = useSession()
  const router = useRouter()
  const location = useLocation()

  useEffect(() => {
    if (status === 'unauthenticated') {
      // Use location.pathname (with language prefix) so Keycloak's redirectUri
      // lands directly on a valid route, avoiding an extra redirect that breaks auth state.
      const callbackUrl = encodeURIComponent(location.pathname || '/account/dashboard')
      router.push(`/login?callbackUrl=${callbackUrl}`)
    }
  }, [status, location.pathname, router])

  if (status === 'loading') {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
          <p className="text-gray-500 font-medium">Loading your session...</p>
        </div>
      </div>
    )
  }

  if (status === 'authenticated') {
    return <>{children}</>
  }

  // Returning null while redirecting
  return null
}
